import { render, staticRenderFns } from "@/modules/OCR/templates/ocr-file-upload.html?vue&type=template&id=76c37426&scoped=true&"
import script from "@/modules/OCR/scripts/ocr-file-upload.ts?vue&type=script&lang=js&"
export * from "@/modules/OCR/scripts/ocr-file-upload.ts?vue&type=script&lang=js&"
import style0 from "@/modules/OCR/styles/ocr-file-upload.scss?vue&type=style&index=0&id=76c37426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c37426",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
